import { KITCHEN_CHARGES_COPY } from '@/components/KitchenCharges/copy';
import { dateLabel } from '@/components/KitchenCharges/chargeDate';
import { formatMoney, formatSignedMoney } from '@/components/KitchenCharges/chargeMoney';

const TICKET_TYPE = 'ticket';
const ADJUSTMENT_TYPE = 'adjustment';
const KEY_SEPARATOR = '-';

function hasLineWithoutPrice(entry) {
  return (entry.lines || []).some((line) => Boolean(line.price_missing));
}

export function isTicket(entry) {
  return entry.type === TICKET_TYPE;
}

export function isAdjustment(entry) {
  return entry.type === ADJUSTMENT_TYPE;
}

export function entryLabel(entry) {
  return isAdjustment(entry) ? KITCHEN_CHARGES_COPY.adjustments.label : entry.ticket_id;
}

export function entryKey(entry) {
  const id = isAdjustment(entry) ? entry.id : entry.ticket_id;
  return [entry.type, id].join(KEY_SEPARATOR);
}

export function isAutomaticAdjustment(entry) {
  return isAdjustment(entry) && Boolean(entry.automatic);
}

export function isEntryIncomplete(entry) {
  return isTicket(entry) && (Boolean(entry.incomplete) || hasLineWithoutPrice(entry));
}

export function entryAmount(entry, currency) {
  return isAdjustment(entry) ? formatSignedMoney(entry.amount, currency) : formatMoney(entry.amount, currency);
}

export function entryRow(entry, currency) {
  return {
    key: entryKey(entry),
    label: entryLabel(entry),
    date: dateLabel(entry.date),
    amount: entryAmount(entry, currency),
    isAdjustment: isAdjustment(entry),
    isAutomatic: isAutomaticAdjustment(entry),
    isIncomplete: isEntryIncomplete(entry),
  };
}
